import React from "react";
import { Button, ButtonProps, Box } from "@mui/material";
import { motion } from "framer-motion";

interface ShimmerButtonProps extends Omit<ButtonProps, "component"> {
  shimmerColor?: string;
  gradientBackground?: string;
  children: React.ReactNode;
}

export const ShimmerButton: React.FC<ShimmerButtonProps> = ({
  shimmerColor = "rgba(255, 255, 255, 0.4)",
  gradientBackground = "linear-gradient(135deg, #10B981 0%, #0D9488 100%)",
  children,
  sx,
  ...props
}) => {
  return (
    <Button
      component={motion.button}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      sx={{
        position: "relative",
        overflow: "hidden",
        background: gradientBackground,
        color: "#FFFFFF",
        fontWeight: 800,
        borderRadius: "14px",
        textTransform: "none",
        boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        transition: "box-shadow 0.3s ease",
        "&:hover": {
          background: gradientBackground,
          boxShadow: "0 6px 20px rgba(16, 185, 129, 0.45)",
        },
        ...sx,
      }}
      {...props}
    >
      {/* Moving Shimmer Beam */}
      <Box
        component={motion.div}
        animate={{
          x: ["-100%", "250%"],
        }}
        transition={{
          repeat: Infinity,
          duration: 3,
          ease: "easeInOut",
          repeatDelay: 1,
        }}
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "40%",
          background: `linear-gradient(90deg, transparent 0%, ${shimmerColor} 50%, transparent 100%)`,
          transform: "skewX(-20deg)",
          pointerEvents: "none",
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1, display: "inline-flex", alignItems: "center", gap: 1 }}>
        {children}
      </Box>
    </Button>
  );
};

export default ShimmerButton;
